import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import Utils from "@utils";
import { ToastContainer } from "react-toastr";
import { connect } from "react-redux";
import { QueryClientProvider } from "@tanstack/react-query";
import QueryClient from "@services/QueryClient";
import { ErrorBoundary, DevTools  } from "../../../components";

const AppWrapper = ({ children, user }) => {
	const toasterRef = useRef(null);

	const notify = ({
		type = "info",
		title = "",
		message = "",
		closeButton = false,
		timeOut = 6000,
		extendedTimeOut = null,
		showAnimation = "animated flipInX",
		hideAnimation = "animated flipOutX",
	}) => {
		const optionsOverride = {
			closeButton,
			timeOut,
			extendedTimeOut,
			showAnimation,
			hideAnimation,
		};

		toasterRef.current[type](message, title, optionsOverride);
	};

	useEffect(() => {
		Utils.registerEventListener("notify", notify);

		return () => {
			Utils.removeEventListener("notify");
		};
	}, []);

	return (
		<QueryClientProvider client={QueryClient}>
			<ErrorBoundary user={user}>
				<div className="app-wrapper">
					{React.Children.map(children, child => React.cloneElement(child, {}))}
				</div>

				<ToastContainer
					ref={toasterRef}
					preventDuplicates={false}
					className="toast-top-right"
				/>

			</ErrorBoundary>
			<DevTools />
		</QueryClientProvider>
	);
};

const mapStateToProps = ({ app: { user } }) => ({
	user,
});

AppWrapper.defaultProps = {
	user: {},
};

AppWrapper.propTypes = {
	children: PropTypes.any.isRequired,
	user: PropTypes.object,
};

export default connect(mapStateToProps, null)(AppWrapper);
